// extracted by mini-css-extract-plugin
export default {"item":"style_item__ly2aY","content":"style_content__Qatk-","address":"style_address__TrLu4","radio":"style_radio__R8Sl7"};